__turbopack_context__.v({
  "body": "style-module-scss-module__Ma6Xja__body",
  "info": "style-module-scss-module__Ma6Xja__info",
  "inlineInfo": "style-module-scss-module__Ma6Xja__inlineInfo",
  "inlineInfo__disableBorder": "style-module-scss-module__Ma6Xja__inlineInfo__disableBorder",
  "inlineInfo__name": "style-module-scss-module__Ma6Xja__inlineInfo__name",
  "inlineInfo__value": "style-module-scss-module__Ma6Xja__inlineInfo__value",
  "inlineInfo__value__silver": "style-module-scss-module__Ma6Xja__inlineInfo__value__silver",
  "name": "style-module-scss-module__Ma6Xja__name",
  "nameBlock": "style-module-scss-module__Ma6Xja__nameBlock",
  "partialPayment": "style-module-scss-module__Ma6Xja__partialPayment",
  "partialPayment__disabled": "style-module-scss-module__Ma6Xja__partialPayment__disabled",
  "partialPayment__text": "style-module-scss-module__Ma6Xja__partialPayment__text",
  "partialPayment__warning": "style-module-scss-module__Ma6Xja__partialPayment__warning",
  "placementsCount": "style-module-scss-module__Ma6Xja__placementsCount",
  "placements__of": "style-module-scss-module__Ma6Xja__placements__of",
  "progress": "style-module-scss-module__Ma6Xja__progress",
  "progress__partialPayment": "style-module-scss-module__Ma6Xja__progress__partialPayment",
  "tariff": "style-module-scss-module__Ma6Xja__tariff",
  "tariff__partialPayment": "style-module-scss-module__Ma6Xja__tariff__partialPayment",
  "tariff__warning": "style-module-scss-module__Ma6Xja__tariff__warning",
});
